/*
  liberty-wishlist.js — favoritos da Liberty Sneakers
  Baseado no wishlist.js da Galeria de Boleiro (localStorage, sem login).

  Diferenças em relação ao original:
  - Injeta o coração nos cards do tema (Shrine) e na PDP, em vez de exigir que
    o botão já exista no Liquid. Com MutationObserver, porque a grade e o
    seletor de variante são re-renderizados por AJAX.
  - Adiciona o coração e o caminhão de rastreio no cabeçalho.
  - Migra a lista antiga do formato só-handle para {handle, ts}.
*/
(function () {
  'use strict';

  var CFG = window.LIBERTY_WISHLIST || {};
  var KEY = 'liberty_wishlist';

  // ---------- armazenamento ----------
  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      // aceita o formato antigo (array de strings)
      return list.map(function (it) {
        return typeof it === 'string' ? { handle: it, ts: 0 } : it;
      }).filter(function (it) { return it && it.handle; });
    } catch (e) { return []; }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: list } }));
    } catch (e) {}
  }

  function has(handle) {
    return read().some(function (it) { return it.handle === handle; });
  }

  function toggle(handle) {
    var list = read();
    var i = list.findIndex(function (it) { return it.handle === handle; });
    if (i === -1) { list.push({ handle: handle, ts: Date.now() }); write(list); return true; }
    list.splice(i, 1); write(list); return false;
  }

  window.LibertyWishlist = { read: read, has: has, toggle: toggle, key: KEY };

  // ---------- ícones ----------
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 5.6a5.2 5.2 0 0 0-7.4 0L12 7l-1.4-1.4a5.2 5.2 0 1 0-7.4 7.4l1.4 1.4L12 21.4l7.4-7.4 1.4-1.4a5.2 5.2 0 0 0 0-7.4z"/></svg>';
  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="5" width="13" height="11" rx="1"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="18.5" cy="18" r="2"/></svg>';

  function handleFromLink(a) {
    if (!a) return '';
    var m = a.getAttribute('href') || '';
    m = m.split('?')[0].split('#')[0];
    var parts = m.split('/products/');
    return parts[1] ? parts[1].replace(/\/$/, '') : '';
  }

  function makeBtn(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lw-btn ' + (cls || '');
    b.setAttribute('data-wishlist-toggle', '');
    b.setAttribute('data-product-handle', handle);
    b.innerHTML = HEART;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var added = toggle(handle);
      b.classList.toggle('is-active', added);
      sync();
    });
    return b;
  }

  // ---------- injeção nos cards da grade ----------
  function injectCards() {
    document.querySelectorAll('.card-wrapper, .lc__card').forEach(function (card) {
      if (card.dataset.lwDone) return;
      var link = card.querySelector('a[href*="/products/"]') ||
                 (card.matches('a[href*="/products/"]') ? card : null);
      var handle = handleFromLink(link);
      if (!handle) return;
      card.dataset.lwDone = '1';

      var host = card.querySelector('.card__inner') || card.querySelector('.lc__media') || card;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(makeBtn(handle, 'lw-btn--card'));
    });
  }

  // ---------- injeção na página do produto ----------
  function injectPdp() {
    if (!CFG.productHandle) return;
    var pos = CFG.pdpPosition || 'title';
    if (pos === 'hide') return;                      // some da PDP, favoritos seguem funcionando
    if (document.querySelector('.lw-btn--pdp')) return;

    var atc = document.querySelector('.main-product-atc, .atc-button, .product-form__submit');
    var target = null, where = 'after';

    if (pos === 'image') {
      var gal = document.querySelector('media-gallery, .product__media-wrapper');
      if (!gal) return;
      if (getComputedStyle(gal).position === 'static') gal.style.position = 'relative';
      var b = makeBtn(CFG.productHandle, 'lw-btn--pdp lw-btn--pdp-image');
      gal.appendChild(b);
      return;
    }

    if (pos === 'atc_before' || pos === 'atc_after') {
      if (!atc) return;
      // sobe ate o container do botao para nao entrar dentro do <button>
      target = atc.closest('.product-form__buttons, .variations_button, .product-form__quantity-and-btn') || atc;
      where = pos === 'atc_before' ? 'before' : 'after';
    } else {
      target = document.querySelector('.product__title, .product__info-wrapper h1, h1.product-title');
      if (!target) return;
    }

    var btn = makeBtn(CFG.productHandle, 'lw-btn--pdp');
    if (CFG.pdpLabel) {
      btn.insertAdjacentHTML('beforeend', '<span class="lw-btn__label">' + CFG.pdpLabel + '</span>');
    }
    var wrap = document.createElement('div');
    wrap.className = 'lw-pdp-wrap lw-pdp-wrap--' + pos;
    wrap.appendChild(btn);

    if (where === 'before') target.parentNode.insertBefore(wrap, target);
    else target.parentNode.insertBefore(wrap, target.nextSibling);
  }

  // ---------- cabeçalho ----------
  function injectHeader() {
    if (document.querySelector('.lw-head')) return;
    var host = document.querySelector('.header__icons');
    if (!host) return;

    var frag = document.createElement('div');
    frag.className = 'lw-head';

    if (CFG.showTracking && CFG.trackingUrl) {
      var t = document.createElement('a');
      t.className = 'lw-head__link';
      t.href = CFG.trackingUrl;
      t.target = '_blank';
      t.rel = 'noopener';
      t.setAttribute('aria-label', CFG.trackingLabel || 'Rastrear pedido');
      t.title = CFG.trackingLabel || 'Rastrear pedido';
      t.innerHTML = TRUCK;
      frag.appendChild(t);
    }

    if (CFG.showWishlistIcon !== false) {
      var w = document.createElement('a');
      w.className = 'lw-head__link lw-head__wish';
      w.href = CFG.pageUrl || '/pages/favoritos';
      w.setAttribute('aria-label', 'Favoritos');
      w.title = 'Favoritos';
      w.innerHTML = HEART + '<span class="lw-head__count" data-wishlist-count>0</span>';
      frag.appendChild(w);
    }

    // antes do carrinho, quando existir
    var cart = host.querySelector('#cart-icon-bubble, [href$="/cart"]');
    if (cart && cart.parentNode === host) host.insertBefore(frag, cart);
    else host.insertBefore(frag, host.firstChild);
  }

  // ---------- sincronização ----------
  function sync() {
    var list = read();
    var handles = list.map(function (it) { return it.handle; });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = handles.indexOf(b.getAttribute('data-product-handle')) !== -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-label', on ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      // So escreve se mudou: textContent troca nos filhos e dispara o
      // MutationObserver, o que criava um laco infinito e travava a pagina.
      var n = String(list.length);
      if (el.textContent !== n) el.textContent = n;
      el.classList.toggle('is-visible', list.length > 0);
    });
  }

  function boot() {
    injectHeader();
    injectCards();
    injectPdp();
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // A grade e a gaveta sao re-renderizadas por AJAX. O observer roda no
  // proximo frame e se desliga enquanto injeta, para nao reagir as proprias
  // mudancas (era isso que travava a pagina).
  var scheduled = false, mo = null;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      if (mo) mo.disconnect();
      try { injectCards(); sync(); } catch (e) {}
      if (mo) mo.observe(document.body, { childList: true, subtree: true });
    });
  }
  mo = new MutationObserver(schedule);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('wishlist:updated', sync);
  // outra aba mexeu na lista
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
})();
